export const Resolution = [
    { key: '', value: 'Select Reason' },
    { key: 'NOTRESOLVED', value: 'Not Resolved' },
    { key: 'RESOLVED', value: 'Resolved' }
];
